/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';
import BluebirdPromise from 'bluebird';
import _ from 'underscore';

import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { isDesktop as _isDesktop } from '@trello/browser';
import { ApiError } from '@trello/error-handling';
import { featureFlagClient } from '@trello/feature-flag-client';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { ProductFeatures } from '@trello/product-features';
import ReactDOM from '@trello/react-dom-wrapper';

import { errorPage } from 'app/scripts/controller/errorPage';
import { Auth } from 'app/scripts/db/Auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { ApiPromise } from 'app/scripts/network/ApiPromise';
import { BillableGuestListPopoverView } from 'app/scripts/views/board/BillableGuestListPopoverView';
import { BoardEntSelectPermLevelView } from 'app/scripts/views/board-menu/BoardEntSelectPermLevelView';
import { BoardOrgSelectPermLevelView } from 'app/scripts/views/board-menu/BoardOrgSelectPermLevelView';
import { View } from 'app/scripts/views/internal/view';
import { Confirm } from 'app/scripts/views/lib/Confirm';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { BoardInviteRestrictValues } from 'app/scripts/views/organization/Constants';
import { CreateOrgView } from 'app/scripts/views/organization/CreateOrgView';
import { PopoverChangeBoardOrgTemplate } from 'app/scripts/views/templates/PopoverChangeBoardOrgTemplate';
import { BillableGuestsAlert } from 'app/src/components/BillableGuestsAlert';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
// eslint-disable-next-line @trello/no-module-logic
const isDesktop = _isDesktop();

interface BoardSelectOrganizationView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  blockTeamlessBoardsEnabled: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  haveAvailableLicenses: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listenTo: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  makeDebouncedMethods: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modelCache: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reactRoot: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedOrganization: any;
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class BoardSelectOrganizationView extends View {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'viewTitleKey' does not exist on type 'Bo... Remove this comment to see the full error message
    this.prototype.viewTitleKey = 'change organization';

    // @ts-expect-error TS(2339): Property 'events' does not exist on type 'BoardSel... Remove this comment to see the full error message
    this.prototype.events = {
      'click .js-submit': 'submit',
      'change .js-org': 'orgSelected',
      'click .js-new-org': 'newOrg',
    };
  }

  initialize() {
    this.makeDebouncedMethods('render');
    this.haveAvailableLicenses = true;
    this.listenTo(this.model, 'change:memberships', this.updateOrgOptions);

    this.blockTeamlessBoardsEnabled = featureFlagClient.get(
      'btg.block-teamless-boards',
      true,
    );
  }

  getTemplateData() {
    let org;
    const data = this.model.toJSON({ org: true });
    // @ts-expect-error TS(2339): Property 'models' does not exist on type 'Organiza... Remove this comment to see the full error message
    let orgs = this.model.owned() ? Auth.me().organizationList.models : [];
    data.isMemberOfBoardOrg = orgs.find(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (o: any) => o.id === data.idOrganization,
    );

    if (this.model.isEnterpriseBoard()) {
      data.hasEnterprise = true;
      data.enterpriseName = this.model.getEnterprise()?.get('displayName');

      orgs = _.filter(orgs, function (org) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const idEnterprise = org.get('idEnterprise');

        if (data.idEnterprise != null && idEnterprise === data.idEnterprise) {
          return true;
        }

        if (
          data.org &&
          idEnterprise &&
          data.org.idEnterprise &&
          idEnterprise === data.org.idEnterprise
        ) {
          return true;
        }

        return false;
      });

      // We'll only show the "Private boards (no team)" option for enterprise boards if they're explicitly
      // owned by the enterprise, i.e. if their `idEnterprise` field is set. When that field is set we know
      // that the board will retain the enterprise ownership status when moved to a user's "private space".
      data.showPrivateBoardsOptionForEntBoards =
        this.model.get('idEnterprise') != null;
    }

    data.orgs = (() => {
      const result = [];
      for (org of Array.from(orgs)) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        result.push(org.toJSON());
      }
      return result;
    })();
    data.hasOrgs = data.orgs.length !== 0;
    data.isDesktop = isDesktop;

    const currentSelection = this.selectedOrganization || data.idOrganization;

    if (currentSelection) {
      for (org of Array.from(data.orgs)) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        if (org.id === currentSelection) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          org.select = true;
        }
      }
    }

    data.isPrivate = this.model.isPrivate();
    data.isTemplate = this.model.isTemplate();
    data.allowsSelfJoin = this.model.allowsSelfJoin();

    data.addToTeam = false;

    return data;
  }

  render() {
    const data = this.getTemplateData();

    Analytics.sendScreenEvent({
      name: 'changeBoardWorkspaceInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
      },
    });

    data.blockTeamlessBoardsEnabled = this.blockTeamlessBoardsEnabled;

    this.$el.html(PopoverChangeBoardOrgTemplate(data));

    this.updateOrgOptions();
    return this;
  }

  remove() {
    if (this.reactRoot) {
      ReactDOM.unmountComponentAtNode(this.reactRoot);
    }
    return super.remove(...arguments);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showOrgBoardVisPerms(organization: any, idOrganizationSource: any) {
    return PopOver.pushView({
      // @ts-expect-error TS(2351): This expression is not constructable.
      view: new BoardOrgSelectPermLevelView({
        model: this.model,
        organization,
        idOrganizationSource,
        modelCache: this.modelCache,
      }),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showEntBoardVisPerms(enterprise: any, idOrganizationSource: any) {
    return PopOver.pushView({
      // @ts-expect-error TS(2351): This expression is not constructable.
      view: new BoardEntSelectPermLevelView({
        model: this.model,
        enterprise,
        idOrganizationSource,
        modelCache: this.modelCache,
      }),
    });
  }

  changeOrg(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    idOrganizationTarget: any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    idOrganizationSource: any,
    settings = {},
  ) {
    const traceId = Analytics.startTask({
      taskName: 'edit-board/idOrganization',
      source: 'changeBoardWorkspaceInlineDialog',
    });
    let targetOrg;
    const orgChanged = idOrganizationTarget !== idOrganizationSource;

    // We aren't subscribed to the boards or the orgs, so we manually update the
    // client-side boardLists
    if (orgChanged && idOrganizationSource) {
      // We may not be able to load the source organization model
      this.modelCache
        .get('Organization', idOrganizationSource)
        ?.boardList?.remove(this.model);
    }

    // @ts-expect-error TS(2339): Property 'idOrganization' does not exist on type '... Remove this comment to see the full error message
    settings.idOrganization = idOrganizationTarget;

    if (idOrganizationTarget) {
      // If we're switching to an organization, we might set additional org
      // friendly permissions.

      // We only show this checkbox if the board is currently private, so it's
      // only used to make a private -> org transition, and if it isn't checked
      // there isn't any change being made
      if ($('.js-make-org-visible', this.$el).is(':checked')) {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        settings['prefs/permissionLevel'] = 'org';
      }

      // We only display this checkbox if the org isn't currently org joinable
      // If it isn't checked then there's no change being made to the org
      if ($('.js-make-org-joinable', this.$el).is(':checked')) {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        settings['prefs/selfJoin'] = true;
      }
    }
    if (orgChanged && idOrganizationTarget) {
      targetOrg = this.modelCache.get('Organization', idOrganizationTarget);
      // @ts-expect-error TS(2339): Property 'keepBillableGuests' does not exist on ty... Remove this comment to see the full error message
      settings.keepBillableGuests =
        (targetOrg != null ? targetOrg.owned() : undefined) &&
        this.haveAvailableLicenses &&
        !isDesktop;
    }

    if (
      this.model.isTemplate() &&
      orgChanged &&
      !this.model.isPublic() &&
      !targetOrg?.hasPaidProduct()
    ) {
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      settings['prefs/isTemplate'] = false;
    }

    // @ts-expect-error TS(2339): Property 'traceId' does not exist on type '{}'.
    settings.traceId = traceId;
    this.model.update(
      settings,
      tracingCallback(
        {
          taskName: 'edit-board/idOrganization',
          source: 'changeBoardWorkspaceInlineDialog',
          traceId,
        },
        (error) => {
          // TRELP-978: Unauthorized error when a team admin moves
          // someone else's private board from BC team to Free team
          if (error instanceof ApiError.Unauthorized) {
            errorPage({
              errorType: 'notPermissionsToSeeBoard',
            });
          }
        },
      ),
    );

    if (targetOrg != null) {
      targetOrg.boardList.add(this.model);
    }

    return PopOver.hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  newOrg(e: any) {
    let createOpts;
    Analytics.sendClickedLinkEvent({
      linkName: 'createNewOrgLink',
      source: 'changeBoardWorkspaceInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
      },
    });

    stopPropagationAndPreventDefault(e);

    if (Auth.me().isPaidManagedEntMember()) {
      createOpts = { boardToAddToOrg: this.model, isEnterprise: true };
    } else {
      const isPrivateTemplate =
        this.model.isTemplate() && !this.model.isPublic();
      createOpts = { boardToAddToOrg: this.model, isPrivateTemplate };
    }

    const trackingOpts = {
      category: 'board',
      method: 'by clicking create team in board change team menu',
    };

    return PopOver.pushView({
      view: new CreateOrgView({
        model: this.model,
        modelCache: this.modelCache,
        createOpts,
        trackingOpts,
      }),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  canAddToOrg(organizationTarget: any) {
    return organizationTarget.canAddBoard(this.model);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submit(e: any) {
    if ($('.js-submit', this.$el).hasClass('disabled')) {
      stopPropagationAndPreventDefault(e);
      return;
    }

    $('.js-submit', this.$el)
      .prop('disabled', true)
      .toggleClass('disabled', true);

    stopPropagationAndPreventDefault(e);
    const idOrganizationTarget = $('.js-org', this.$el).val();
    const idOrganizationSource = this.model.get('idOrganization');
    const organizationTarget = this.modelCache.get(
      'Organization',
      idOrganizationTarget,
    );

    Analytics.sendUpdatedBoardFieldEvent({
      field: 'organization',
      source: 'changeBoardWorkspaceInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          // @ts-expect-error TS(2322): Type 'string | number | string[] | undefined' is n... Remove this comment to see the full error message
          id: idOrganizationTarget,
        },
      },
      attributes: {
        previous: idOrganizationSource,
        change: idOrganizationTarget !== idOrganizationSource,
      },
    });

    return BluebirdPromise.try(() => {
      const targetMembershipRestricted =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        organizationTarget && organizationTarget.boardMembershipRestricted();

      if (!targetMembershipRestricted) {
        return;
      }

      const boardInviteRestrict = organizationTarget.getPref(
        'boardInviteRestrict',
      );
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const filterRestrictedMembers = function (member: any) {
        switch (boardInviteRestrict) {
          case BoardInviteRestrictValues.ORG:
            return !organizationTarget.isMember(member);
          case BoardInviteRestrictValues.MANAGED:
            return !member.isManagedEntMemberOf(
              organizationTarget.get('idEnterprise'),
            );
          case BoardInviteRestrictValues.ORG_OR_MANAGED:
            return (
              !organizationTarget.isMember(member) &&
              !member.isManagedEntMemberOf(
                organizationTarget.get('idEnterprise'),
              )
            );
          default:
        }
      };

      // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
      return ModelLoader.loadOrganizationMembersData(idOrganizationTarget).then(
        () => {
          const restrictedMembers = this.model.memberList
            .chain()
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .filter((member: any) => filterRestrictedMembers(member))
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((member: any) => member.get('fullName'))
            .value();

          const count = restrictedMembers.length;

          if (count === 0) {
            return;
          }

          const confirmKey = (() => {
            switch (boardInviteRestrict) {
              case BoardInviteRestrictValues.ORG:
                if (count === 1) {
                  return 'external member not allowed';
                } else {
                  return 'external members not allowed';
                }
              case BoardInviteRestrictValues.MANAGED:
                if (count === 1) {
                  return 'non managed member not allowed';
                } else {
                  return 'non managed members not allowed';
                }
              case BoardInviteRestrictValues.ORG_OR_MANAGED:
                if (count === 1) {
                  return 'external and non managed member not allowed';
                } else {
                  return 'external and non managed members not allowed';
                }
              default:
            }
          })();

          return BluebirdPromise.fromNode((next) => {
            return Confirm.toggle(confirmKey, {
              elem: e.currentTarget,
              model: this.model,
              confirmBtnClass: 'nch-button nch-button--danger',
              templateData: {
                count: String(count),
                members:
                  restrictedMembers.length > 20
                    ? _.first(restrictedMembers, 20).join(', ') + '…'
                    : restrictedMembers.join(', '),
                team: organizationTarget.get('displayName'),
              },
              fxConfirm: () => {
                // @ts-expect-error TS(2554): Expected 1-2 arguments, but got 0.
                return next();
              },
              fxCancel: () => {
                return next(new Error('cancelled'));
              },
            });
          });
        },
      );
    })
      .then(() => {
        if (
          organizationTarget &&
          (organizationTarget.isFeatureEnabled('restrictVis') ||
            this.model.getPref('permissionLevel') === 'enterprise')
        ) {
          // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
          return ModelLoader.loadOrganizationMembersData(idOrganizationTarget)
            .then(() => {
              if (this.canAddToOrg(organizationTarget)) {
                this.changeOrg(idOrganizationTarget, idOrganizationSource);
              } else {
                this.showOrgBoardVisPerms(
                  organizationTarget,
                  idOrganizationSource,
                );
              }
            })
            .done();
        } else if (this.model.get('idEnterprise')) {
          const enterprise = this.model.getEnterprise();
          if (enterprise && !enterprise.canAddTeamlessBoard(this.model)) {
            this.showEntBoardVisPerms(enterprise, idOrganizationSource);
          } else {
            return this.changeOrg(idOrganizationTarget, idOrganizationSource);
          }
        } else {
          return this.changeOrg(idOrganizationTarget, idOrganizationSource);
        }
      })
      .error(function () {})
      .done();
  }

  showTemplateAlert() {
    return $('.js-template-alert', this.$el).addClass('show-template-alert');
  }

  hideTemplateAlert() {
    return $('.js-template-alert', this.$el).removeClass('show-template-alert');
  }

  allowBoardCreate() {
    $('.js-submit', this.$el).removeClass('disabled');
    $('.js-board-limits-upgrade-ad', this.$el).addClass('hide');
    return $('.js-permissions', this.$el).removeClass('hide');
  }

  updateOrgOptions() {
    $('.js-submit', this.$el).addClass('disabled');
    $('.js-billable-guests-warning', this.$el).addClass('hide');

    this.selectedOrganization = $('.js-org', this.$el).val();
    const hasOrgSelected = this.selectedOrganization !== '';

    $('.js-make-org-visible,.js-make-org-joinable', this.$el)
      .closest('.js-check-div')
      .toggleClass('hide', !hasOrgSelected);

    // show template alert message if trying to move a non-public template to a free or personal team
    if (
      this.model.isTemplate() &&
      !this.model.isPublic() &&
      this.model.get('idOrganization') !== this.selectedOrganization
    ) {
      const targetOrg = this.modelCache.get(
        'Organization',
        this.selectedOrganization,
      );

      if (!hasOrgSelected || !targetOrg?.hasPaidProduct()) {
        this.showTemplateAlert();
      } else {
        this.hideTemplateAlert();
      }
    } else {
      this.hideTemplateAlert();
    }

    if (!hasOrgSelected) {
      this.hideSpinner();
      this.allowBoardCreate();
      return;
    }

    this.showSpinner();

    if (this.model.get('idOrganization') === this.selectedOrganization) {
      this.hideSpinner();
      this.allowBoardCreate();
      return;
    }

    return BluebirdPromise.all([
      ApiPromise({
        type: 'GET',
        url: `/1/organizations/${this.selectedOrganization}/newBillableGuests/${this.model.id}`,
      }),
      ModelLoader.loadOrganizationMembersMinimalWithAvailableLicenseCount(
        this.selectedOrganization,
      ),
    ])
      .spread((newBillableGuests, org) => {
        // Show the 'new' board limits CTA
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        if (org != null ? org.isAtOrOverFreeBoardLimit() : undefined) {
          $('.js-board-limits-upgrade-ad', this.$el).removeClass('hide');
          $('.js-permissions', this.$el).addClass('hide');
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          $('.js-target-team', this.$el).text(org.get('displayName'));
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          $('.js-upgrade-link', this.$el).attr('href', org.getBillingUrl());
          return this.hideSpinner();

          // Show the new billable guests information
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
        } else if (newBillableGuests.length > 0) {
          this.renderBillableGuestAlert({ org, newBillableGuests });
          return (this.haveAvailableLicenses =
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            newBillableGuests.length <= org.getAvailableLicenseCount());
        } else {
          return this.allowBoardCreate();
        }
      })
      .finally(() => {
        return this.hideSpinner();
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderBillableGuestAlert({ org, newBillableGuests }: any) {
    const productCode = org.getProduct();
    const props = {
      adminNames: org.adminList.map(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (member: any) => member.get('fullName') || member.get('username'),
      ),
      newBillableGuestsCount: newBillableGuests.length,
      availableLicenseCount: org.getAvailableLicenseCount(),
      orgName: org.get('displayName') || org.get('name'),
      isMonthly: ProductFeatures.isMonthly(productCode),
      isOrgAdmin: org.owned(),
      orgUrl: org.url,
      isReopen: false,
      isDesktop,
      onCountClick: () =>
        PopOver.pushView({
          // @ts-expect-error TS(2351): This expression is not constructable.
          view: new BillableGuestListPopoverView({ newBillableGuests }),
        }),
    };

    // eslint-disable-next-line @trello/enforce-variable-case
    const Element = <BillableGuestsAlert {...props} />;
    this.reactRoot = this.el.querySelector('.js-billable-guests-warning');
    ReactDOM.render(Element, this.reactRoot);
    $('.js-billable-guests-warning', this.$el).removeClass('hide');
    return this.allowBoardCreate();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  orgSelected(e: any) {
    return this.updateOrgOptions();
  }

  showSpinner() {
    $('.js-loading', this.$el).toggleClass('hide', false);
    return $('.js-loaded', this.$el).toggleClass('hide', true);
  }

  hideSpinner() {
    $('.js-loading', this.$el).toggleClass('hide', true);
    return $('.js-loaded', this.$el).toggleClass('hide', false);
  }
}

BoardSelectOrganizationView.initClass();
export { BoardSelectOrganizationView };
